// reducer.js
const initialState = {
    loading: false,
    // other states...
  };
  
  const loadingReducer = (state = initialState, action) => {
    switch (action.type) {
      case "LOADING":
        return { ...state, loading: action.payload };
      // other cases...
      default:
        return state;
    }
  };
  
  export default loadingReducer;  